export const getCountryFlagByCountryId = (baseUrl, countryCode, imageOptions) => {
    if (!baseUrl || !countryCode || !imageOptions) {
        return undefined;
    }
    const queryParams = new URLSearchParams(imageOptions);
    return new URL(`${baseUrl}v1/countries/${countryCode}/image?${queryParams}`);
};
//# sourceMappingURL=getCountryFlagByCountryId.js.map